import { render } from "./HtmlTabletFormComponent.vue?vue&type=template&id=688fb779"
import script from "./HtmlTabletFormComponent.vue?vue&type=script&lang=js"
export * from "./HtmlTabletFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__